export enum SettingsResources {
    JobIntegrationPause = '/v2/applicantTracker/jobPostings/:atsJobId/pause',
}
